import { Box, Button, Dialog, IconButton, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMenuItem = styled(MenuItem)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '25px',
    backgroundColor: '#FFFFFF',
    minWidth: '680px',
  },
}));

export const DialogContainer = styled(Box)(() => ({
  padding: '60px',
  minHeight: '380px',
}));

export const TopBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  right: '20px',
  top: '20px',
  position: 'absolute',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  textTransform: 'lowercase',
  marginLeft: 'auto',
  marginTop: '12px',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const FormStyled = styled(Box)(() => ({
  width: '100%',
  margin: '32px 0',
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
}));
